/* Bandeau de logos : lecture de `settings.logos`. Aucune marque n'est écrite ici.
   Module partagé par la page React et par scripts/prerender.js. */

export const logosActifs = (settings) =>
  [...((settings || {}).logos || [])]
    .filter((l) => l && l.actif)
    .sort((a, b) => (a.ordre || 0) - (b.ordre || 0));

/* Taille affichée = base × echelle_auto × echelle. Un logo sans `echelle_auto`
   (fichier ajouté après la dernière mesure) s'affiche à 1 : il n'est jamais masqué,
   et l'anomalie est journalisée côté administration, pas à l'écran. */
export const facteur = (entree) =>
  Math.round(((entree.echelle_auto || 1) * (entree.echelle || 1)) * 100) / 100;

export const sansMesure = (settings) =>
  logosActifs(settings).filter((l) => l.logo && !l.echelle_auto).map((l) => l.nom);

/* Durée d'une boucle complète, calculée sur la largeur de la piste : chaque case
   occupe 188 px sur ordinateur (160 de case, 14 de marge de chaque côté), et la piste
   défile à 64 px par seconde — 20 % plus lentement que les 80 px/s précédents.
   Trente-huit logos donnent donc environ 112 secondes par boucle. */
const LARGEUR_CASE = 188;
const VITESSE = 64;

export const dureeBoucle = (marques) =>
  `${Math.round((marques.length * LARGEUR_CASE) / VITESSE)}s`;
